import React from 'react'
import Topbar from '../Topbar/Topbar';
import { useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import './View_Complaint.css'
import { FaUserEdit } from "react-icons/fa";
import { MdEdit } from "react-icons/md";
import { useRef, useEffect } from 'react';
import _ from 'lodash';
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import MessageBox from '../MessageBox/MessageBox';
import OrderDetails_Complaint from './OrderDetails_Complaint';
import Verification_Complaint from './Verification_Complaint';
import WorkAssign_Complaint from './WorkAssign_Complaint';
import WorkDetails_Complaint from './WorkDetails_Complaint';
import Feedback_Complaint from './Feedback_Complaint';
import Payment_Complaint from './Payment_Complaint';
import { useLocation } from "react-router-dom";
import axios from "axios";
import { useSelector } from "react-redux";

export default function View_Complaint() {
  const location = useLocation();
  const taskId = location.state?.taskId;


  console.log(taskId, 826382)
  const permissions = useSelector((state) => state.permissions);

  const { leadId, activeTabWorkAssign: routeActiveTab,tabInfo, hideAssignButton, isSubmittedTab } = location.state || {};
  const [messageData, setMessageData] = useState([]);
  const [selectedNames, setSelectedNames] = useState([]);
  const [originalComplaint, setOriginalComplaint] = useState(null);
  const [names, setNames] = useState([]);
  const [approvePersons, setApprovePersons] = useState([]);
  const [isApproveOpen, setIsApproveOpen] = useState(false);
  const approveDropdownRef = useRef(null);
  const [searchText, setSearchText] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("orderDetails");
  const [pageRefId, setpageRefId] = useState("")
  const [originalData, setOriginalData] = useState({});
  const [isEditable, setIsEditable] = useState(false);
  const [complaintDetails, setComplaintDetails] = useState({});
  const [isEditMode, setIsEditMode] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const staffName = useSelector((state) => state.staffname);
  const Id = useSelector((state) => state.id);
  const navigate = useNavigate();
  const [activeTabWorkAssign, setActiveTabWorkAssign] = useState("fiberTeam");

  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const locate = useLocation();
  const payload = locate?.state;
  const [isOpenAssign, setIsOpenAssign] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [complaintId, setComplaintId] = useState(null);
  const [showMessageBox, setShowMessageBox] = useState(false);
  const [namesApprove, setNamesApprove] = useState([]);


  const [taskData, setTaskData] = useState({
    taskName: 'Complaint',
    assignDateTime: '',
    taskType: 'Once',
    taskPriority: 'Low',
    deadline: '',
    time: '',
    assignedTo: [],
    approvePerson: '',
    description: '',
    name: complaintDetails?.complaintcustomerAffected || '',
    leadId: complaintDetails?.leadId,
    taskStatus: 'Open',
    assignedBy: '',
    activeTab: activeTab
  });

  const dropdownRef = useRef(null);
  const dropdownRefOtt = useRef(null);

  const filteredNames = namesApprove.filter(staff =>
    staff.staffName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  useEffect(() => {
    if (locate.state?.id) {
      axios
        .post(apiUrl + "get-complaint", {
          id: locate.state.id,
        })
        .then((res) => {
          const data = res.data.message;
          setComplaintDetails(data);
          setOriginalData(data);
          setpageRefId(res.data.message._id)
          setComplaintId(data._id);
          
          // Set default work assign tab based on dependent selection
          if (!data.complaintfiber && data.complaintnetwork) {
            setActiveTabWorkAssign("networkTeam");
          } else {
            setActiveTabWorkAssign("fiberTeam");
          }

          // Handle location data if it exists
          if (data.location && typeof data.location === 'object') {
            setComplaintDetails(prev => ({
              ...prev,
              locationString: `Lat: ${data.location.latitude}, Lng: ${data.location.longitude}`
            }));
          }
        })
        .catch((err) => console.error("Fetch failed", err));
    }
  }, [locate.state?.id, apiUrl]);

useEffect(() => {
  console.log("Route Active Tab (workAssign subtab):", routeActiveTab);

  if (routeActiveTab === "fiberTeam" || routeActiveTab === "networkTeam") {
    setActiveTab("workAssign"); // Always go to workAssign tab
    setActiveTabWorkAssign(routeActiveTab); // fiberTeam or networkTeam
  }
}, [routeActiveTab]);


 useEffect(() => {
  setTaskData(prev => ({
    ...prev,
    activeTabWorkAssign: activeTabWorkAssign
  }));
}, [activeTabWorkAssign]);


  useEffect(() => {
    if (payload?.activeTab) {
      setActiveTab(payload.activeTab);
    }
  }, [payload]);

  useEffect(() => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const formattedDate = `${year}-${month}-${day}T${hours}:${minutes}`;

    setTaskData(prev => ({
      ...prev,
      assignDateTime: formattedDate
    }));
  }, []);

  useEffect(() => {
    axios.get(apiUrl + "get-staff-names")
      .then((res) => {
        if (res.data.message) {
          const allStaff = res.data.message;
          let filtered = [];

          if (activeTabWorkAssign === "fiberTeam") {
            filtered = allStaff.filter(
              staff =>
                staff.designation === "Fiber Engineer" ||
                staff.designation === "Marketing / Fiber"
            );
          } else if (activeTabWorkAssign === "networkTeam") {
            filtered = allStaff.filter(
              staff =>
                staff.designation === "Network Admin" ||
                staff.designation === "Network Engineer"
            );
          }


          let filteredApprove = [];

          if (activeTabWorkAssign === "fiberTeam") {
            filteredApprove = allStaff.filter(
              staff =>
                staff.designation === "Network Admin" ||
                staff.designation === "Admin"
            );
          } else if (activeTabWorkAssign === "networkTeam") {
            filteredApprove = allStaff.filter(
              staff =>
                staff.designation === "Network Admin" ||
                staff.designation === "Admin"
            );
          }

          setNamesApprove(filteredApprove);

          setNames(filtered);
        }
      })
      .catch((err) => {
        console.log("Error fetching staff names:", err);
      });

    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [activeTabWorkAssign]);




  const handleCheckboxChange = (staff) => {
    setSelectedNames(prev => {
      const exists = prev.find(item => item._id === staff._id);
      if (exists) {
        return prev.filter(item => item._id !== staff._id);
      } else {
        return [...prev, staff];
      }
    });
  };

   const formatDateTimeLocal = (date) => {
   const year = date.getFullYear();
   const month = (date.getMonth() + 1).toString().padStart(2, "0");
   const day = date.getDate().toString().padStart(2, "0");
   const hours = date.getHours().toString().padStart(2, "0");
   const minutes = date.getMinutes().toString().padStart(2, "0");
 
   return `${year}-${month}-${day}T${hours}:${minutes}`;
 };
 
 
 
 useEffect(() => {
   if (taskData.assignDateTime) {
     const assignDate = new Date(taskData.assignDateTime);
     const deadlineDate = new Date(assignDate.getTime() + 4 * 60 * 60 * 1000); // +4 hours
     const formattedDeadline = formatDateTimeLocal(deadlineDate);
 
     setTaskData(prev => ({
       ...prev,
       deadline: formattedDeadline
     }));
   }
 }, [taskData.assignDateTime]);
 
 
  
   useEffect(() => {
     if (taskData.assignDateTime) {
       const assignDate = new Date(taskData.assignDateTime);
       const deadlineDate = new Date(assignDate.getTime() + 4 * 60 * 60 * 1000); // +4 hours
       const formattedDeadline = formatDateTimeLocal(deadlineDate);
   
       setTaskData(prev => ({
         ...prev,
         deadline: formattedDeadline
       }));
     }
   }, [taskData.assignDateTime]);
 
 
 const handleInputChange = (field, value) => {
   if (field === 'assignDateTime') {
     const assignDate = new Date(value);
     const deadlineDate = new Date(assignDate.getTime() + 4 * 60 * 60 * 1000);
     const formattedDeadline = deadlineDate.toISOString().slice(0, 16);
 
     setTaskData(prev => ({
       ...prev,
       assignDateTime: value,
       deadline: formattedDeadline // auto update
     }));
   } else {
     setTaskData(prev => ({
       ...prev,
       [field]: value
     }));
   }
 };
 
   const toggleApproveDropdown = () => {
     setIsApproveOpen(prev => !prev);
   };

   const handleApproveCheckboxChange = (staff) => {
     setApprovePersons(prev => {
       const exists = prev.find(item => item._id === staff._id);
       if (exists) {
         return prev.filter(item => item._id !== staff._id);
       } else {
         return [...prev, staff];
       }
     });
   };

   const approvePersonText = approvePersons.length > 0
     ? approvePersons.map(item => item.staffName).join(', ')
     : 'Select Approve Persons';

   const displayText = selectedNames.length > 0
     ? selectedNames.map(item => item.staffName).join(', ')
     : 'Select names';

   const toggleDropdown = () => {
     setIsOpen(prev => !prev);
   };




   const [fiberTeamStock, setFiberTeamStock] = useState({
    updatedBy: staffName,
    updatedTime: new Date().toLocaleTimeString(),
    updatedDate: new Date().toLocaleDateString(),
    materials: [],
  });

  const [networkTeamStock, setNetworkTeamStock] = useState({
    updatedBy: staffName,
    updatedTime: new Date().toLocaleTimeString(),
    updatedDate: new Date().toLocaleDateString(),
    materials: [],
  });



  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    if (isEditMode) {
      const hasChanges = !_.isEqual(complaintDetails, originalComplaint);
      if (!hasChanges) {
        Swal.fire("No Changes", "No changes were made to update.", "info");
        setIsSubmitting(false);
        return;
      }
    }

    const result = await Swal.fire({
      title: "Update the changes?",
      showCancelButton: true,
      confirmButtonText: "Update",
    });

    if (!result.isConfirmed) {
      setIsSubmitting(false);
      return;
    }

    try {
      let updatedComplaintDetails = { ...complaintDetails };

      // === Timestamp setup ===
      const now = new Date();
      const updatedDate = `${String(now.getDate()).padStart(2, "0")}-${String(now.getMonth() + 1).padStart(2, "0")}-${now.getFullYear()}`;
      const updatedTime = `${(now.getHours() % 12 || 12)}:${String(now.getMinutes()).padStart(2, "0")} ${now.getHours() >= 12 ? "PM" : "AM"}`;

      // === Audit trail ===
      updatedComplaintDetails[activeTab] = {
        ...(updatedComplaintDetails[activeTab] || {}),
        updatedBy: staffName,
        updatedDate,
        updatedTime,
      };

      // === WorkAssign tab ===


if (activeTab === "workAssign" && activeTabWorkAssign === "fiberTeam") {
  const prevFiberTeam = complaintDetails?.workAssign?.fiberTeam || {};
  const prevMaterials = prevFiberTeam.materials || [];
  const newMaterials = fiberTeamStock.materials || [];

  updatedComplaintDetails.workAssign = {
    ...complaintDetails.workAssign,
    fiberTeam: {
      ...prevFiberTeam,
      ...fiberTeamStock,
      materials: [...prevMaterials, ...newMaterials],
      isCompleted: true,
      approvedStatus: "Approved", // ✅ mark as approved so allCompleted triggers
      materialsSelected: true,
      updatedBy: staffName,
      updatedDate,
      updatedTime,
    },
  };
}

if (activeTab === "workAssign" && activeTabWorkAssign === "networkTeam") {
  const prevNetworkTeam = complaintDetails?.workAssign?.networkTeam || {};
  const prevMaterials = prevNetworkTeam.materials || [];
  const newMaterials = networkTeamStock.materials || [];

  updatedComplaintDetails.workAssign = {
    ...complaintDetails.workAssign,
    networkTeam: {
      ...prevNetworkTeam,
      ...networkTeamStock,
      materials: [...prevMaterials, ...newMaterials],
      isCompleted: true,
      approvedStatus: "Approved", // ✅ mark as approved so allCompleted triggers
      materialsSelected: true,
      updatedBy: staffName,
      updatedDate,
      updatedTime,
    },
  };


   const workDetailPayload = {
                  type: "complaint", // You can change this to "complaint" or "installation" as needed
                  pageRefId: complaintDetails._id,
                  staffId: Id,
                  staffName: staffName,
                  actionStatus: "complete",
                  // Optional fields:
                  // bikeType: ...,
                  // cableUsed: ...,
                  // location: { latitude: ..., longitude: ... },
                };
    
                try {
                  await axios.post(apiUrl + "work-detail", workDetailPayload, {
                    headers: { "Content-Type": "application/json" },
                  });
                  console.log("Work detail logged successfully.");
                } 
                catch (err) {
                  console.error("Work detail logging failed:", err.response?.data || err.message);
                }
}



      // === Verification tab ===
      else if (activeTab === "verification") {
        const status = updatedComplaintDetails.verification?.verificationStatus;
        updatedComplaintDetails.verification = {
          ...(updatedComplaintDetails.verification || {}),
          isCompleted: status === "Verified",
          updatedBy: staffName,
          updatedDate,
          updatedTime,
        };

        // Add verification message
        const formData = new FormData();
        const verificationStatus = complaintDetails.verification?.verificationStatus?.toLowerCase().trim();
        let colorCode = verificationStatus === "verified" ? "#2c693a" :
          verificationStatus === "open" ? "#ffc107" :
            verificationStatus === "not available" ? "#ff0000" : "black";

        formData.append("pageRefId", complaintDetails._id);
        formData.append("page", "Installation");
        formData.append("colorCode", colorCode);
        formData.append(
          "description",
          `${complaintDetails.verification?.notes || ""} (${complaintDetails.verification?.verificationStatus || "Not Available"})`
        );
        formData.append("staffPic", "");
        if (selectedFile) formData.append("image", selectedFile);
        formData.append("updatesHistory[staff][name]", staffName);
        formData.append("updatesHistory[staff][id]", Id);
        formData.append("updatesHistory[status]", "Verification");

        await axios.post(apiUrl + "add-message", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        const res = await axios.get(`${apiUrl}messages/${pageRefId}`);
        setMessageData(res.data.data);
        setShowMessageBox(true);
      }

      // === Feedback tab ===
      else if (activeTab === "feedback") {
        updatedComplaintDetails.feedback = {
          ...(updatedComplaintDetails.feedback || {}),
          isCompleted: true,
          updatedBy: staffName,
          updatedDate,
          updatedTime,
        };
      }

      // === Payment tab ===
      else if (activeTab === "payment") {
        // If clicking global submit on payment tab, just mark current state as isCompleted 
        // if total paid matches.
        const totalPaid = (updatedComplaintDetails.payment?.items || []).reduce((acc, item) => acc + (Number(item.payAmount) || 0), 0);
        const totalCharge = Number(updatedComplaintDetails.complaintadditionalCharges) || 0;
        
        updatedComplaintDetails.payment = {
          ...(updatedComplaintDetails.payment || {}),
          isCompleted: totalPaid >= totalCharge
        };
      }


      // === Task status update (Crucial fix) ===
      if (["workAssign", "workDetails"].includes(activeTab)) {
        const fiberDone = updatedComplaintDetails.workAssign?.fiberTeam?.isCompleted;
        const networkDone = updatedComplaintDetails.workAssign?.networkTeam?.isCompleted;

        let currentTeamDone = false;
        if (activeTabWorkAssign === "fiberTeam") {
          currentTeamDone = fiberDone;
        } else if (activeTabWorkAssign === "networkTeam") {
          currentTeamDone = networkDone;
        } else {
          // If neither specifically active (e.g. general workDetails), check if at least one is done
          currentTeamDone = fiberDone || networkDone;
        }

        if (currentTeamDone) {
          await axios.put(apiUrl + "update-task", {
            id: taskId,
            updateData: {
              taskStatus: "Completed",
              taskUpdatedBy: {
                staffName,
                _id: Id,
                time: updatedTime,
                date: updatedDate,
              },
            },
          });
        } else {
          await axios.put(apiUrl + "update-task", {
            id: taskId,
            updateData: {
              taskStatus: "Progress",
              taskUpdatedBy: {
                staffName,
                _id: Id,
                time: updatedTime,
                date: updatedDate,
              },
            },
          });
        }
      }

      // === Final save to complaint ===
      await axios.post(apiUrl + "update-lead-complaint", updatedComplaintDetails, {
        headers: { "Content-Type": "application/json" },
      });

      Swal.fire("Success!", "Data updated successfully", "success");
      setIsEditable(false);
      setIsEditMode(false);
      
      // Navigate away
      navigate(
        (["orderDetails", "verification", "feedback", "payment"].includes(activeTab) || !hideAssignButton)
          ? "/complaint"
          : "/task"
      );
    } catch (error) {
      Swal.fire("Error", error.response?.data?.message || "Something went wrong!", "error");
    } finally {
      setIsSubmitting(false);
    }
  };


useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
      if (approveDropdownRef.current && !approveDropdownRef.current.contains(event.target)) {
        setIsApproveOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);



  const isCurrentTabCompleted = () => {
    if (!complaintDetails) return false;

    switch (activeTab) {
      case "verification":
        return complaintDetails.verification?.isCompleted === true;

      case "workAssign":
        // Only check teams that are selected as dependents
        const fiberSelected = complaintDetails.complaintfiber;
        const networkSelected = complaintDetails.complaintnetwork;
        const fiberCompleted = complaintDetails.workAssign?.fiberTeam?.isCompleted;
        const networkCompleted = complaintDetails.workAssign?.networkTeam?.isCompleted;

        if (fiberSelected && networkSelected) {
          return fiberCompleted === true && networkCompleted === true;
        } else if (fiberSelected) {
          return fiberCompleted === true;
        } else if (networkSelected) {
          return networkCompleted === true;
        }
        return false;


      case "feedback":
        return complaintDetails.feedback?.isCompleted === true;

      case "payment":
        return complaintDetails.payment?.isCompleted === true;

      default:
        return false;
    }
  };
  const handleSubmitAssignTask = async (e) => {
    e.preventDefault();

    Swal.fire({
      title: "Are you sure you want to create this task?",
      showCancelButton: true,
      confirmButtonText: "Submit",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const now = new Date();
          const day = String(now.getDate()).padStart(2, "0");
          const month = String(now.getMonth() + 1).padStart(2, "0");
          const year = now.getFullYear();
          const updatedDate = `${day}-${month}-${year}`;

          let hours = now.getHours();
          const minutes = String(now.getMinutes()).padStart(2, "0");
          const ampm = hours >= 12 ? "PM" : "AM";
          hours = hours % 12 || 12;
          const updatedTime = `${hours}:${minutes} ${ampm}`;

          const datas = {
            ...taskData,
            assignedBy: {
              staffName: staffName,
              id: Id
            },
            updatedDate,
            updatedTime,
            assignedTo: selectedNames,
            approvePerson: approvePersons,
            collectionId: complaintId,
            activeTab: activeTab
          };

          const requiredFields = [
            "taskName",
            "assignDateTime",
            "deadline",
            "assignedTo",
            "approvePerson",
            "description",
          ];

          const emptyFields = requiredFields.filter(
            (field) => !datas[field] || (Array.isArray(datas[field]) && datas[field].length === 0)
          );

          if (emptyFields.length > 0) {
            Swal.fire({
              icon: "warning",
              title: "Incomplete Data",
              text: `Please fill all the required fields`,
            });
            return;
          }

          const response = await axios.post(
            apiUrl + "add-assign-task",
            datas,
            { headers: { "Content-Type": "application/json" } }
          );
if (taskData.activeTabWorkAssign === "fiberTeam") {
  await axios.post(apiUrl + "update-lead-complaint", {
    leadId:complaintDetails.leadId,
    "workAssign.fiberTeam.fiberTeamAssigned": true // ✅ only one field
  });
}


        else if (taskData.activeTabWorkAssign === "networkTeam") {
          await axios.post(apiUrl + "update-lead-complaint", {
             leadId: complaintDetails.leadId,
    "workAssign.networkTeam.networkTeamAssigned": true 
          });
        }
          Swal.fire({
            title: "Task Created Successfully!",
            icon: "success",
          }).then(() => {
            navigate("/task");
          });
        } catch (error) {
          console.log("Error submitting data:", error.response?.data || error.message);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: error.response?.data?.message || "Something went wrong!",
          });
        }
      }
    });
  };


  useEffect(() => {
    if (complaintDetails) {
      setTaskData(prev => ({
        ...prev,
        name: complaintDetails.complaintcustomerAffected || '',
        leadId: complaintDetails.leadId || '' // if you also want to set leadId here
      }));
    }
  }, [complaintDetails]);

  useEffect(() => {
    const fetchMessages = async () => {
      try {
        const response = await axios.get(`${apiUrl}messages/${pageRefId}`);

        if (response.status === 200 && Array.isArray(response.data.data)) {
          setMessageData(response.data.data); // ✅ Only the array!
        } else {
          console.error("Unexpected response structure:", response);
          setMessageData([]); // fallback to empty array
        }
      } catch (error) {
        console.error("Error fetching messages:", error);
        setMessageData([]); // fallback to empty array
      }
    };

    fetchMessages();
  }, [apiUrl, pageRefId]);
  const renderContent = () => {
    switch (activeTab) {
      case "orderDetails":
        return (
          <OrderDetails_Complaint
            complaintDetails={complaintDetails}
            setComplaintDetails={setComplaintDetails}
            isEditable={isEditable}
          />
        );
      case "verification":
        return (
          <Verification_Complaint
            complaintDetails={complaintDetails}
            setComplaintDetails={setComplaintDetails}
            isEditable={isEditable}
            selectedFile={selectedFile}
            setSelectedFile={setSelectedFile}
          />
        );
      case "workAssign":
        return (
          <WorkAssign_Complaint
            complaintDetails={complaintDetails}
            setComplaintDetails={setComplaintDetails}
            isEditable={isEditable}
            setActiveTabWorkAssign={setActiveTabWorkAssign}
            activeTabWorkAssign={activeTabWorkAssign}

            fiberTeamStock={fiberTeamStock}
            setFiberTeamStock={setFiberTeamStock}
            networkTeamStock={networkTeamStock}
            setNetworkTeamStock={setNetworkTeamStock}
          />
        );
      case "workDetails":
        return (
          <WorkDetails_Complaint
            complaintDetails={complaintDetails}
            setComplaintDetails={setComplaintDetails}
            isEditable={isEditable}
          />
        );
      case "feedback":
        return (
          <Feedback_Complaint
            complaintDetails={complaintDetails}
            setComplaintDetails={setComplaintDetails}
            isEditable={isEditable}
          />
        );
      // case "payment":
      //   return (
      //     <Payment_Complaint
      //       complaintDetails={complaintDetails}
      //       setComplaintDetails={setComplaintDetails}
      //       isEditable={isEditable}
      //     />
      //   );

      case "payment":
        return (
          // complaintDetails?.complaintadditionalCharges &&
          complaintDetails?.complaintadditionalCharges !== "0" ||
            complaintDetails?.complaintadditionalCharges !== "null" ||
            complaintDetails?.complaintadditionalCharges !== ""
            ? <Payment_Complaint
              complaintDetails={complaintDetails}
              setComplaintDetails={setComplaintDetails}
              isEditable={isEditable}
            />
            : null
        );

      default:
        return <div>Select a tab</div>;
    }
  };


  useEffect(() => {
    // Reset edit mode when leaving orderDetails tab
    if (activeTab !== 'orderDetails') {
      setIsEditMode(false);
      setIsEditable(false);
    }
  }, [activeTab]);


  const getFutureDateTime = () => {
    const now = new Date();
    now.setMinutes(now.getMinutes() + 1); // add 1 minute to current time
    return now.toISOString().slice(0, 16); // returns 'YYYY-MM-DDTHH:MM'
  };


  return (
    <div>
      <Topbar />
      <Container fluid>
        <form onSubmit={handleSubmit}>
          <Row className='mt-4'>
            <Col className='text-start'>
              <h3>Complaint</h3>
            </Col>
            <Col className='text-end'>
              {isOpenAssign && (
                <div className="overlay3">
                  <div className="modal3">
                    <Container>
                      <div className=" text-end mx-2">
                        <button
                          type="button"
                          className="black-btn mx-3"
                          onClick={() => setIsOpenAssign(false)}
                        >
                          Cancel
                        </button>
                        <button
                          type="button"
                          className="blue-btn mx-3"
                          onClick={handleSubmitAssignTask}
                        >
                          Submit
                        </button>
                      </div>

                      <Row className="mt-4">
                        <Col xs={12} md={6}>
                          <Row>
                            <Col xs={12} md={6} className="text-start">
                              <label>Task Name</label>
                              <br />
                              <input
                                type="text"
                                className="form-input"
                                readOnly
                                value={taskData.taskName}
                              />
                            </Col>
                            <Col xs={12} md={6} className="text-start">
                              <label>Assign Date/Time</label>
                              <br />
                              <input
                                type="datetime-local"
                                value={taskData.assignDateTime}
                                required
                                className="form-input"
                                onChange={(e) => handleInputChange('assignDateTime', e.target.value)}
                              />
                            </Col>
                          </Row>
                        </Col>
                        <Col>
                          <Row>
                            <Col xs={12} md={6} className="text-start">
                              <label>Task Priority </label>
                              <br />
                              <select
                                onChange={(e) =>
                                  handleInputChange("taskPriority", e.target.value)
                                }
                                className="dropbtn form-input-select overlay2"
                              >
                                <option value="Low">Low</option>
                                <option value="High">High</option>
                                <option value="Immediate">Immediate</option>
                              </select>
                            </Col>

                            <Col xs={12} md={6} className="text-start">
                              <label>Deadline Date/Time</label>
                              <br />
                                                                                   <input
  type="datetime-local"
  value={taskData.deadline || ""}
  min={getFutureDateTime()} // optional: restrict past values
  onChange={(e) =>
    handleInputChange("deadline", e.target.value)
  }
  className="form-input overlay2"
/>
                            </Col>

                          </Row>
                        </Col>
                      </Row>

                      <Row>
                        <Col xs={12} md={6}>
                          <Row>
                            <Col xs={12} md={6} className="text-start">
                              <label>Lead ID</label>
                              <br />
                              <input
                                type="text"
                                value={taskData.leadId}
                                className="form-input overlay2"
                                readOnly
                              />
                            </Col>



                            <Col xs={12} md={6} className="text-start">
                              <label>Name </label>
                              <br />
                              <input
                                type="text"
                                onChange={(e) =>
                                  handleInputChange("name", e.target.value)
                                }
                                style={{ textTransform: "capitalize" }}
                                className="form-input "
                                placeholder="Enter Notes "
                                readOnly
                                value={taskData.name}
                              />
                            </Col>

                            {/* <Col xs={12} md={6} className="text-start">
                              <label>Deadline Time</label>
                              <br />
                              <input
                                type="time"
                                onChange={(e) =>
                                  handleInputChange("time", e.target.value)
                                }
                                className="form-input overlay2"
                                placeholder=""
                              />
                            </Col> */}
                          </Row>
                        </Col>
                        <Col>
                          <Row>
                            <Col xs={12} md={6} className="text-start">
                              <label>Task Assign To</label>
                              <br />
                              <div ref={dropdownRef} style={{ position: 'relative', width: '85%' }}>
                                <div
                                  onClick={toggleDropdown}
                                  style={{
                                    padding: '10px',
                                    border: '2px solid #a7a7a7',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    backgroundColor: '#fff',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    marginTop: "10px"
                                  }}
                                >
                                  <span style={{
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap'
                                  }}>
                                    {displayText}
                                  </span>
                                  <span>{isOpen ? '▲' : '▼'}</span>
                                </div>

                                {isOpen && (
                                  <div style={{
                                    position: 'absolute',
                                    top: '100%',
                                    left: 0,
                                    right: 0,
                                    marginTop: '5px',
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                    backgroundColor: '#fff',
                                    boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
                                    zIndex: 1000,
                                    maxHeight: '250px',
                                    overflowY: 'auto'
                                  }}>
                                    <input
                                      type="text"
                                      placeholder="Search staff..."
                                      value={searchText}
                                      onChange={(e) => setSearchText(e.target.value)}
                                      style={{
                                        width: '95%',
                                        margin: '10px auto',
                                        display: 'block',
                                        padding: '8px',
                                        borderRadius: '4px',
                                        border: '1px solid #ccc'
                                      }}
                                    />

                                    {names.filter(staff =>
                                      staff.staffName.toLowerCase().includes(searchText.toLowerCase())
                                    ).length === 0 ? (
                                      <div style={{ padding: '10px', color: '#888', textAlign: 'center' }}>
                                        No Staffs found
                                      </div>
                                    ) : (
                                      names.filter(staff =>
                                        staff.staffName.toLowerCase().includes(searchText.toLowerCase())
                                      ).map((staff) => (
                                        <label
                                          key={staff._id}
                                          style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            padding: '10px',
                                            cursor: 'pointer',
                                            borderBottom: '1px solid #eee',
                                          }}
                                        >
                                          <input
                                            type="checkbox"
                                            checked={selectedNames.some(item => item._id === staff._id)}
                                            onChange={() => handleCheckboxChange(staff)}
                                            style={{ marginRight: '10px' }}
                                            required
                                          />
                                          {staff.staffName}
                                        </label>
                                      ))
                                    )}
                                  </div>
                                )}
                              </div>
                            </Col>

                            <Col xs={12} md={6} className="text-start">
                              <label>Approve Person </label>
                              <br />
                              <div ref={approveDropdownRef} style={{ position: 'relative', width: '85%', marginTop: '15px' }}>
                                <div
                                  onClick={toggleApproveDropdown}
                                  style={{
                                    padding: '10px',
                                    border: '2px solid #a7a7a7',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    backgroundColor: '#fff',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    marginTop: '-5px'
                                  }}
                                >
                                  <span style={{
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap'
                                  }}>
                                    {approvePersonText}
                                  </span>
                                  <span>{isApproveOpen ? '▲' : '▼'}</span>
                                </div>

                                {isApproveOpen && (
                                  <div style={{
                                    position: 'absolute',
                                    top: '100%',
                                    left: 0,
                                    right: 0,
                                    marginTop: '5px',
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                    backgroundColor: '#fff',
                                    boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
                                    zIndex: 1000,
                                    maxHeight: '250px',
                                    overflowY: 'auto'
                                  }}>
                                    <input
                                      type="text"
                                      placeholder="Search staff..."
                                      value={searchTerm}
                                      onChange={(e) => setSearchTerm(e.target.value)}
                                      style={{
                                        width: '100%',
                                        padding: '8px 10px',
                                        borderBottom: '1px solid #ccc',
                                        boxSizing: 'border-box',
                                        outline: 'none',
                                        border: 'none'
                                      }}
                                    />

                                    {filteredNames.length === 0 ? (
                                      <div style={{ padding: '10px', color: '#888', textAlign: 'center' }}>
                                        No staff found
                                      </div>
                                    ) : (
                                      filteredNames.map((staff) => (
                                        <label
                                          key={staff._id}
                                          style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            padding: '10px',
                                            cursor: 'pointer',
                                            borderBottom: '1px solid #eee',
                                          }}
                                        >
                                          <input
                                            type="checkbox"
                                            required
                                            checked={approvePersons.some((item) => item._id === staff._id)}
                                            onChange={() => handleApproveCheckboxChange(staff)}
                                            style={{ marginRight: '10px' }}
                                          />
                                          {staff.staffName}
                                        </label>
                                      ))
                                    )}
                                  </div>
                                )}
                              </div>
                            </Col>
                          </Row>
                        </Col>
                      </Row>

                      <Row>
                        <Col xs={12} md={6} className="text-start">
                          <label>Description</label>
                          <br />
                          <textarea
                            type="text"
                            onChange={(e) =>
                              handleInputChange("description", e.target.value)
                            }
                            style={{
                              textTransform: "capitalize",
                              resize: "none",
                            }}
                            className="form-input inputfield-assign "
                            placeholder="Enter Notes "
                          />
                        </Col>
                        <Col>
                          <Row>

                            <Col xs={12} md={6} className="text-start">
                              <label>Task Status </label>
                              <br />
                              <input
                                type="text"
                                onChange={(e) =>
                                  handleInputChange("taskStatus", e.target.value)
                                }
                                style={{
                                  backgroundColor: "#fbdc6e",
                                  color: "rgb(94, 94, 14)",
                                  textTransform: "capitalize",
                                }}
                                className="form-input "
                                readOnly
                                value={taskData.taskStatus}
                              />
                            </Col>
                          </Row>
                          <Row>

                          </Row>
                        </Col>
                      </Row>
                    </Container>
                  </div>
                </div>
              )}



              {!isEditable && activeTab === "orderDetails" && (
                <button
                  className="black-btn me-2"
                  type="button"
                  onClick={() => {
                    // Store a deep copy of current form data before editing
                    setOriginalComplaint(JSON.parse(JSON.stringify(complaintDetails)));
                    setIsEditable(true);
                    setIsEditMode(true);
                  }}
                >
                  <MdEdit size={18} /> Edit
                </button>
              )}



              {isEditMode && isEditable && (
                <>
                  {/* Submit Button */}
                  <button className="blue-btn ms-2 me-3" type="submit">
                    Submit
                  </button>

                  {/* Cancel Button */}
                  <button
                    className="black-btn ms-2 me-3"
                    type="button"
                    onClick={() => {
                      setComplaintDetails(JSON.parse(JSON.stringify(originalComplaint)));
                      setIsEditable(false);
                      setIsEditMode(false);
                    }}
                  >
                    Cancel
                  </button>
                </>
              )}



              {(
                (activeTab === 'orderDetails') ||
                ['verification', 'payment', 'workAssign', 'workDetails', 'feedback',].includes(activeTab)
              ) && (
                  <>


                    {(!isCurrentTabCompleted() &&
                      (
                        hideAssignButton ||
                        activeTab === "verification" ||
                        activeTab === "feedback" ||
                        activeTab === "payment"
                      ) ||
                      (
                        hideAssignButton && activeTab === "workAssign" && activeTabWorkAssign === "fiberTeam" &&
                        complaintDetails?.workAssign?.fiberTeam?.isCompleted !== true

                      ) ||

                      (
                        (
                          hideAssignButton && activeTab === "workAssign" &&
                          complaintDetails?.workAssign?.networkTeam?.isCompleted !== true

                        )
                      )
                    ) && (
                        <>
                          {
                            (
                              complaintDetails?.workAssign?.fiberTeam?.isCompleted !== true && activeTabWorkAssign === "fiberTeam") && (
                              <button className="blue-btn ms-2 me-3" type="submit">Submit</button>
                            )
                          }
                          {
                            (
                              complaintDetails?.workAssign?.networkTeam?.isCompleted !== true && activeTabWorkAssign === "networkTeam") && (
                              <button className="blue-btn ms-2 me-3" type="submit">Submit</button>
                            )
                          }

                        </>
                      )}


                      {/* {tabInfo?.resubmittedData === true &&
 activeTabWorkAssign === "fiberTeam" &&
 complaintDetails?.workAssign?.fiberTeam?.approvedStatus === "Resubmit" &&
 activeTab === "workAssign" && (
  <button className="blue-btn ms-2 me-3 e" type="submit">
    Submit
  </button>
)} */}

{tabInfo?.resubmittedData === true &&
  activeTabWorkAssign === "networkTeam" &&
  (tabInfo?.reComplete || complaintDetails?.workAssign?.networkTeam?.approvedStatus === "Resubmit") &&
  activeTab === "workAssign" && (
    <button className="blue-btn ms-2 me-3 e" type="submit">
      Submit
    </button>
  )}




{activeTab === "feedback" && complaintDetails.feedback?.isCompleted !== true &&
  (
    (complaintDetails?.complaintfiber && complaintDetails?.workAssign?.fiberTeam?.approvedStatus === "Approved") ||
    (complaintDetails?.complaintnetwork && complaintDetails?.workAssign?.networkTeam?.approvedStatus === "Approved") ||
    complaintDetails?.workAssign?.isCompleted
  ) && (
  <button className="blue-btn ms-2 me-3 e" type="submit">
    Submit
  </button>
)}
                    {/* <button
                                  className="black-btn ms-2 me-3"
                                  type="button"
                                  onClick={() => {
                                    setcomplaintDetails(JSON.parse(JSON.stringify(originalComplaint)));
                                    setIsEditable(false);
                                    setIsEditMode(false);
                                  }}
                                >
                                  Cancel
                                </button> */}

                    {/* {!['Not Feasible', 'Cancelled', 'Converted'].includes(complaintDetails.leadStatus) && (
                                  <button
                                    className="blue-btn me-5"
                                    type="button"
                                    onClick={() => {
                                      setTaskData({
                                        ...taskData,
                                        name: complaintDetails.enquirycustomerName || '',
                                        leadId: complaintDetails.leadId || '',
                                      });
                                      setIsOpenAssign(true);
                                    }}
                                  >
                                    <FaUserEdit size={18} /> Assign
                                  </button>
                                )} */}
                    {permissions?.Installation?.["Installation Task Assign"]?.Read &&
                      !hideAssignButton &&
                      !isCurrentTabCompleted() &&
                      activeTab !== "orderDetails" &&
                      activeTab !== "verification" &&
                      activeTab !== "feedback" &&
                      activeTab !== "payment" &&
                      !(isEditMode && isEditable) && (
                        <button
                          className="blue-btn me-5"
                          type="button"
                          onClick={() => setIsOpenAssign(true)}
                        >
                          <FaUserEdit size={18} /> Assign
                        </button>
                      )}




                  </>
                )}

              {/* {(
                (activeTab === 'orderDetails' && isEditMode && isEditable) ||
                ['verification', 'payment', 'workAssign', 'workDetails', 'feedback'].includes(activeTab)
              ) && (
                  <>
                    {(!isCurrentTabCompleted() && hideAssignButton) && (
                      <button className="blue-btn ms-2 me-3" type="submit">Submit</button>
                    )}

                    {permissions?.Complaint?.["Complaint Task Assign"]?.Read &&
                      !hideAssignButton &&
                      !isCurrentTabCompleted() && (
                        <button
                          className="blue-btn me-5"
                          type="button"
                          onClick={() => {
                            setTaskData({
                              ...taskData,
                              name: complaintDetails.enquirycustomerName || '',
                              leadId: complaintDetails.leadId || '',
                            });
                            setIsOpenAssign(true);
                          }}
                        >
                          <FaUserEdit size={18} /> Assign
                        </button>
                      )}

                  </>
                )} */}
            </Col>
          </Row>

         <div className="tabs-container mt-5">
  <div className="tabs">
    <Row className="mb-3">
      {/* Complaint Details */}
      <Col>
        <button
          type="button"
          className={`order-details-btn ${activeTab === "orderDetails" ? "active" : "inactive"}`}
          onClick={() => setActiveTab("orderDetails")}
        >
          Complaint Details
        </button>
      </Col>

      {/* Verification */}
      <Col>
        <button
          type="button"
          className={`order-details-btn ${activeTab === "verification" ? "active" : "inactive"}`}
          onClick={() => setActiveTab("verification")}
        >
          Verification
        </button>
      </Col>

      {/* Work Assign */}
      {complaintDetails?.verification?.isCompleted && (
        <Col>
          <button
            type="button"
            className={`order-details-btn ${activeTab === "workAssign" ? "active" : "inactive"}`}
            onClick={() => setActiveTab("workAssign")}
          >
            Work Assign
          </button>
        </Col>
      )}

      {/* Work Details - show if selected team(s) have been approved */}
      {(
        (complaintDetails?.complaintfiber && complaintDetails?.workAssign?.fiberTeam?.approvedStatus === "Approved") ||
        (complaintDetails?.complaintnetwork && complaintDetails?.workAssign?.networkTeam?.approvedStatus === "Approved") ||
        complaintDetails?.workAssign?.isCompleted
      ) && (
        <Col>
          <button
            type="button"
            className={`order-details-btn ${activeTab === "workDetails" ? "active" : "inactive"}`}
            onClick={() => setActiveTab("workDetails")}
          >
            Work Details
          </button>
        </Col>
      )}

      {/* Feedback - show if selected team(s) have been approved */}
      {(
        (complaintDetails?.complaintfiber && complaintDetails?.workAssign?.fiberTeam?.approvedStatus === "Approved") ||
        (complaintDetails?.complaintnetwork && complaintDetails?.workAssign?.networkTeam?.approvedStatus === "Approved") ||
        complaintDetails?.workAssign?.isCompleted
      ) && (
        <Col>
          <button
            type="button"
            className={`order-details-btn ${activeTab === "feedback" ? "active" : "inactive"}`}
            onClick={() => setActiveTab("feedback")}
          >
            Feedback
          </button>
        </Col>
      )}

      {/* Payment */}
      {complaintDetails?.complaintadditionalCharges != null &&
        complaintDetails?.complaintadditionalCharges !== "" &&
        complaintDetails?.complaintadditionalCharges !== 0 && (
          <Col>
            <button
              type="button"
              className={`order-details-btn ${activeTab === "payment" ? "active" : "inactive"}`}
              onClick={() => setActiveTab("payment")}
            >
              Payment
            </button>
          </Col>
        )}
    </Row>
  </div>

  <div className="tab-content">
    {renderContent()}
  </div>
</div>

        </form>

        <Row className="container ms-3 me-5">
          <Col md={6} sm={12}>
            <div>
              {Array.isArray(messageData) && messageData.length > 0 ? (
                messageData.map((msg) => (
                  <MessageBox key={msg._id} message={msg} />
                ))
              ) : (
                <div className="text-muted">No messages available.</div>
              )}
            </div>
          </Col>

          <Col md={6} sm={12}>
            <div className="compact-updates-history">
              <div className="compact-updates-header">Updates History</div>
              {Array.isArray(messageData) && messageData.length > 0 ? (
                messageData.map((data, index) => (
                  <div className="compact-update text-center" key={index}>
                    <div className="compact-update-date text-center">
                      {data.updatesHistory.date ? (
                        new Date(data.updatesHistory.date).toLocaleDateString("en-GB") +
                        " - " +
                        new Date(data.updatesHistory.date)
                          .toLocaleTimeString("en-US", {
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: true,
                          })
                      ) : (
                        "No date"
                      )}
                    </div>

                    <div className="compact-update-user text-center">
                      {data.updatesHistory?.staff?.name || "Unknown"}
                    </div>

                    <div
                      className="compact-update-status text-center"
                      style={{ color: data.colorCode || "#000000" }}
                    >
                      {data.updatesHistory?.status || "No Status"}
                    </div>
                  </div>
                ))
              ) : (
                <div className="text-muted text-center">No update history available.</div>
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}